import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { footerContent, footerLinks, heroContent, } from "../../constants/appData";
import { FooterLinks } from "../../utils/utils";
const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (_jsxs("footer", { className: "footer", children: [_jsxs("h2", { className: "prompt", children: [_jsx("span", { className: "prompt-symbol", "aria-hidden": "true", children: "$" }), " ", footerContent.heading] }), _jsx(FooterLinks, { links: footerLinks }), _jsx("p", { className: "footer-privacy", children: footerContent.privacyNotice }), _jsxs("p", { className: "footer-copyright", children: ["\u00A9 ", currentYear, " ", heroContent.name] })] }));
};
export default Footer;
